const { NODE_ENV: SERVER_ENV, VUE_APP_LOG_LEVEL: LOG_LEVEL } = process.env;

export { SERVER_ENV, LOG_LEVEL };
